import React, { Component } from "react";
import { injectIntl, intlShape } from "@ai360/core/intl";
import PropTypes from "prop-types";

import { DataTable } from "~/core";
import { withCrud } from "~/hocs";
import { FormattingHelpers } from "@ai360/core";

import { service, actions } from "./log-data";
import { messages } from "../i18n-messages";

export class GeneLog_ extends Component {
    static propTypes = {
        records: PropTypes.array,
        intl: intlShape.isRequired,
    };
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.records) {
            for (let item of nextProps.records) {
                FormattingHelpers.formatLogDetailText(item);
            }
        }
    }
    render() {
        return (
            <DataTable
                service={service}
                isCheckbox={false}
                showFilterInput={false}
                messages={messages}
                {...this.props}
            />
        );
    }
}
export const GeneLog = injectIntl(withCrud(GeneLog_, service, actions));
